import type { WerkcurveOutput } from '../types';

/** Names and meanings from spaik-context/werkcurve.md; keep the wording identical. */
export const WERKCURVE_LEVELS: Record<WerkcurveOutput['level'], { name: string; who: string }> = {
  L0: { name: 'AI als theater', who: 'Mensen doen al het werk. Er wordt over AI gepraat, er verandert niets.' },
  L1: { name: 'AI als denkpartner', who: 'Mensen doen het werk, AI denkt mee.' },
  L2: { name: 'AI als assistent', who: 'Mensen doen het werk, AI maakt ze sneller.' },
  L3: { name: 'AI als collega', who: 'AI doet zelf een taak binnen een kernproces, met een eigenaar erop.' },
  L4: { name: 'AI als systeem', who: 'Agents draaien volledige workflows, gekoppeld aan jullie systemen.' },
  L5: { name: 'AI als zelfsturend systeem', who: 'Agents draaien het hele kernproces binnen kaders.' },
};

export const QUADRANTS: Record<WerkcurveOutput['use_cases'][number]['quadrant'], { name: string; meaning: string }> = {
  automatiseren: { name: 'Automatiseren', meaning: 'Door AI gedaan' },
  versterken: { name: 'Versterken', meaning: 'AI doet het werk, jullie controleren' },
  evalueren: { name: 'Evalueren', meaning: 'Splitsen: het standaarddeel naar AI, het lastige deel bij jullie' },
  leiden: { name: 'Leiden', meaning: 'Jullie leiden, AI denkt mee' },
};
